<template>
    <v-card class="search-bar-card" flat>
        <v-toolbar class="search-bar" floating>
            <v-text-field
                @input="$emit('input', $event)"
                hide-details
                single-line
                autocomplete="off"
                placeholder="Enter a Game Title"
            >
            </v-text-field>
            <v-btn icon :ripple="false">
                <v-icon color="black " size="30">mdi-magnify</v-icon>
            </v-btn>
        </v-toolbar>
    </v-card>
</template>

<script>
export default {
    name: 'search-bar',
};
</script>
<style lang="scss" scoped>
.search-bar-card {
    width: 100%;
    min-width: 360px;
    margin: -30px 0 53px 0;
    border-radius: 0;
    .search-bar {
        width: 100%;
        padding-left: 10px;
        padding-right: 30px;
        box-shadow: 0 25px 25px -20px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        border: solid 1px #cbcbcb;
    }
}

@include break('sm') {
    .search-bar-card {
        margin: -30px 30px 83px 30px;
        border-radius: 10px;
        width: calc(
            100vw - 136px
        ); // 30px margin on each side + 16px scroll bar
    }
}
@include break('md') {
    .search-bar-card {
        margin: -30px 50px 83px 50px;
        width: calc(
            100vw - 232px
        ); // 58px margin on each side + 16px scroll bar
        .search-bar {
            padding-left: 10px;
            padding-right: 40px;
        }
    }
}
@include break('lg') {
    .search-bar-card {
        margin: -30px 120px 83px 120px;
        width: calc(
            100vw - 372px
        ); // 58px margin on each side + 16px scroll bar
    }
}
@include break('xl') {
    .search-bar-card {
        margin: -30px auto 83px auto;
    }
}
</style>
<style lang="scss">
.v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none;
}
.v-text-field > .v-input__control > .v-input__slot:after {
    // border-style: none;
    border-color: #2960e8;
}
.v-toolbar__content {
    width: 100%;
}
</style>
